// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"754":"7f4d09fb","765":"be9b3666","890":"de4a18b7","952":"ead52c45"}[chunkId] + ".chunk.js";
};